import {
  SHOW_INFO_DIALOG,
} from './actionTypes'


export const showInfoDialog = params => ({ type: SHOW_INFO_DIALOG, payload: { params } })
